module.exports = __webpack_public_path__ + "small-logo-black.svg?087dc91e8264146d0776cad6a49a489a";